import { SchemaModifier } from '../types';
import { generateSchema } from '../SchemaGeneration';

const contactModifier: SchemaModifier = (
  content,
  main,
  parts,
  state,
  partial,
) => {
  if (content?.email) {
    main['email'] = content.email;
  }
  if (content?.last_name) {
    main['familyName'] = content.last_name;
  }
  if (content?.first_name) {
    main['givenName'] = content.first_name;
  }
  if (content?.phone1) {
    main['telephone'] = content.phone1;
  }
  if (content?.['@components']?.university) {
    main['worksFor'] = generateSchema({
      type: content['@components'].university['@type'],
      content: content['@components'].university,
      state,
      partial: true,
    });
  }
};

export default contactModifier;
